import React from 'react';

const BenefitCard = ({ icon, title, description }) => {
  return (
    <div className="group rounded-2xl border border-gray-100 shadow-sm hover:shadow-2xl transition-all duration-300 p-8 text-center">
      <div className="flex justify-center mb-5">
        
      </div>
      <h3 className="text-lg font-medium text-gray-800 mb-2 group-hover:text-emerald-600 transition-colors">
        {title}
      </h3>
      <p className="text-gray-500 text-sm leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default BenefitCard;